import {
    ButtonGroup,
    Divider,
    IconButton,
    Popover,
    PopoverArrow,
    PopoverBody,
    PopoverContent,
    PopoverTrigger,
    Portal,
    SimpleGrid,
    useBreakpointValue,
    VStack,
} from "@chakra-ui/react"
import { ModalType } from "component/Modal/type"
import { PerpButton } from "component/PerpButton"
import { Stats } from "component/Stats"
import { useModal } from "container/modal"
import { EventName } from "module/analytics/types"
import { ICollateralStr } from "module/vault/hook/useCollateralStrings"
import { RiMoreFill } from "react-icons/ri"

interface CollateralActionsProps {
    data: ICollateralStr
    isDisabled?: boolean
    isCollapsed?: boolean
}
export function CollateralActions({ data, isDisabled, isCollapsed }: CollateralActionsProps) {
    const { walletBalanceStr: walletAmount, freeCollateralStr: available } = data

    const { open: openModalDeposit } = useModal(ModalType.DEPOSIT)
    const { open: openModalWithdraw } = useModal(ModalType.WITHDRAW)

    const handleDepositBtn = () => {
        openModalDeposit({ collateralData: data })
    }

    const handleWithdrawBtn = () => {
        openModalWithdraw({ collateralData: data })
    }

    const buttonSize = useBreakpointValue({ base: "md", md: "sm" })

    // show as popover if isCollapsed
    return isCollapsed ? (
        <Popover colorScheme="blackAlpha" placement="bottom-start" arrowSize={8}>
            <PopoverTrigger>
                <IconButton size="sm" aria-label="more" isRound icon={<RiMoreFill />} />
            </PopoverTrigger>
            <Portal>
                <PopoverContent>
                    <PopoverArrow />
                    <PopoverBody>
                        <VStack spacing={3} py={2}>
                            <SimpleGrid columns={2} spacing={3} width="100%">
                                <Stats number={walletAmount} label="Wallet" size="md" />
                                <Stats number={available} label="Withdrawable" size="md" />
                            </SimpleGrid>
                            <Divider />
                            <ButtonGroup w="full" size={buttonSize}>
                                <PerpButton
                                    isDisabled={isDisabled}
                                    width="full"
                                    onClick={handleWithdrawBtn}
                                    trackingProps={{
                                        eventName: EventName.VAULT_COLLATERAL_WITHDRAW_CLICK,
                                        description: `from component: ${CollateralActions.name}`,
                                    }}
                                >
                                    Withdraw
                                </PerpButton>
                                <PerpButton
                                    width="full"
                                    onClick={handleDepositBtn}
                                    colorScheme="green"
                                    trackingProps={{
                                        eventName: EventName.VAULT_COLLATERAL_DEPOSIT_CLICK,
                                        description: `from component: ${CollateralActions.name}`,
                                    }}
                                >
                                    Deposit
                                </PerpButton>
                            </ButtonGroup>
                        </VStack>
                    </PopoverBody>
                </PopoverContent>
            </Portal>
        </Popover>
    ) : (
        <ButtonGroup size={buttonSize} width="100%">
            <PerpButton
                isDisabled={isDisabled}
                width="full"
                onClick={handleWithdrawBtn}
                trackingProps={{
                    eventName: EventName.VAULT_COLLATERAL_WITHDRAW_CLICK,
                    description: `from component: ${CollateralActions.name}`,
                }}
            >
                Withdraw
            </PerpButton>
            <PerpButton
                width="full"
                onClick={handleDepositBtn}
                colorScheme="green"
                trackingProps={{
                    eventName: EventName.VAULT_COLLATERAL_DEPOSIT_CLICK,
                    description: `from component: ${CollateralActions.name}`,
                }}
            >
                Deposit
            </PerpButton>
        </ButtonGroup>
    )
}
